import React, { useRef, useState } from 'react';
import CompGridPlayer from '@components/grid/comp-grid-player.js';
import CompFormPlayer from '@components/form/comp-form-player.js';
import CompFormPlayerCompetitionApply from '@components/form/comp-form-playerCompetitionApply.js';
import SearchForm from '@components/form/fragment/comp-fmt-search.js';
import ButtonForm from '@components/form/fragment/comp-fmt-button.js';
import {removeGrid} from '@assets/js/api/commonApi.js';

const PlayerMng = (props) => {
    /****************************
     * Define required variables
    *****************************/
    const childRef = useRef();
    const childGridRef = useRef();
    const childPlyrApplyRef = useRef();
    const [params, setParams] = useState({});
    const [selectedRows, setSelectedRows] = useState([]);

    /**************************
     * Define button functions
    ***************************/
    const onNew = () => {
        childRef.current.modalToggle({mode: 'I'});
    }
    const onModify = (params) => {
        childRef.current.modalToggle({mode: 'M', ...params});
    }
    const onRemove = () => {
        if (selectedRows.length === 0) { alert('1건이상 선택해주세요.'); return; }
        const idsArray = [...selectedRows.ids];
        if (idsArray.length === 0) {
            alert('삭제할 항목을 선택해주세요.');
            return;
        }

        const deleteParams = {
            deleteList: idsArray.map(rowId => {
                const parts = rowId.split('-');
                return {
                    mngCd: parts[0],
                    dvsnGrpCd: parts[1],
                    dvsnCd: parts[2]
                };
            })
        };

        removeGrid('/sys/plymng/remove/info', deleteParams, {
            msg: {
                confirm: '선택된 ' + idsArray.length + '개 항목을 삭제하시겠습니까?',
            }
        }).then(res => {
            if (res && res.success) {
                //clear selected rows grid.
                setSelectedRows(new Set());
                onGridSearch();
            }
        });
    }
    //선택된 선수들 대상 대회 신청하기. (ADMIN 기능)
    const onCompetitionApply = () => {
        if (!selectedRows || !selectedRows.data || selectedRows.data.length === 0) {
            alert('1건이상 선택해주세요.');
            return;
        }

        childPlyrApplyRef.current.modalToggle({plyrAppList : selectedRows.data});
    }

    const onGridSearch = () => {
        childGridRef.current.onGridSearch(params);
    }
    const onValChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value
        setParams({ ...params, [id]: value });
    }

    /****************************
     * Define form config
    *****************************/
    const formObj = {
        id : 'searchForm',
        params : {
            plyrNm : {
                id : 'plyrNm',
                label : '선수명',
                maxLength : 30
            },
            email : {
                id : 'email',
                label : '이메일',
                maxLength : 30
            },
            telno : {
                id : 'telno',
                label : '전화번호',
                maxLength : 30
            },
        }
    }
    const buttonConfig = {
        fncButtons: [
            { id: 'competitionApply', label: '대회신청하기', className: 'btn-primary', onClick: onCompetitionApply },
        ],
        leftButtons: [
            { id: 'new', label: 'New', className: 'btn-success', onClick: onNew },
            { id: 'remove', label: 'Remove', className: 'btn-danger', onClick: onRemove }
        ],
        rightButtons: [
            { id: 'search', label: 'Search', className: 'btn-primary', onClick: onGridSearch }
        ]
    }

    return (
        <>
            {/* SearchForm */}
            <SearchForm formObj={formObj} onValChange={onValChange} onGridSearch={onGridSearch} params={params}/>

            {/* ButtonForm */}
            <ButtonForm buttonConfig={buttonConfig} />
            
            {/* Grid */}
            <CompGridPlayer ref={childGridRef} onChildClick={onModify} onSelectionChange={setSelectedRows}/>

            {/* Player Save Modal popup */}
            <CompFormPlayer ref={childRef} onGridSearch={onGridSearch} />
            
            {/* Player Competition apply Modal popup */}
            <CompFormPlayerCompetitionApply ref={childPlyrApplyRef} onGridSearch={onGridSearch} />
        </> 
    );
}

export default PlayerMng;
